// extracted by mini-css-extract-plugin
export var colorSquare = "_op-0";
export var danger = "_op-5";
export var lightPink = "_op-8";
export var neutralBlue = "_op-7";
export var neutralYellow = "_op-6";
export var normal = "_op-1";
export var primary = "_op-2";
export var primaryLight = "_op-3";
export var solidBlack = "_op-g";
export var solidGreen = "_op-b";
export var solidLightBlue = "_op-d";
export var solidNavy = "_op-c";
export var solidOrange = "_op-f";
export var solidPink = "_op-e";
export var solidRed = "_op-9";
export var solidYellow = "_op-a";
export var success = "_op-4";